import { z } from 'zod';
import { AvatarFormatSchema, AvatarVariantSchema } from '../../shared/avatar.schema';
/**
 * Get Avatar Request Schema
 * GET /api/v2/users/:userId/avatar/:version/:variant.:format
 *
 * Path parameters:
 * - userId: the user whose avatar is requested
 * - version: opaque cache key for the stored avatar (see below)
 * - variant: which rendered size to serve
 * - format: which encoding to serve
 *
 * `version` is opaque to the client on purpose: callers echo back whatever the
 * user payload carried rather than deriving it, so the server can change how
 * it is minted (upload timestamp today, a key hash tomorrow) without a client
 * release. It only ever participates in cache addressing — the response always
 * carries the user's current avatar, and a stale version is not an error.
 */ export const GetAvatarRequestSchema = z.object({
    userId: z.string(),
    version: z.string(),
    variant: AvatarVariantSchema,
    format: AvatarFormatSchema
});
/**
 * Get Tenant User Avatar Request Schema
 * GET /api/v2/tenants/:tenantId/users/:userId/avatar/:version/:variant.:format
 *
 * The superadmin-facing twin: the target tenant rides in the path, matching
 * every other cross-tenant superadmin endpoint (`/tenants/:tenantId/users/…`).
 * Members of a tenant use the unprefixed route, which resolves the tenant from
 * the session instead — a caller can never widen their own reach by choosing a
 * different path.
 */ export const GetTenantUserAvatarRequestSchema = GetAvatarRequestSchema.extend({
    tenantId: z.string()
});
/**
 * Get Avatar Response Schema
 *
 * The endpoint answers with raw image bytes (`image/webp` or `image/jpeg`),
 * not JSON, so there is no parseable body shape — validation is the
 * content-type header, mirroring the ZIP data export.
 */ export const GetAvatarResponseSchema = z.instanceof(Blob).optional();

//# sourceMappingURL=get-avatar.schema.js.map